import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Button, Input, InputAdornment, TextField} from "@mui/material";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import KeyIcon from '@mui/icons-material/Key';
import logo from "../../assets/images/newssum_logo.svg";
import styles from '../../assets/styles/modules/Login.module.css'
import {loginAPI} from '../../apis/user_service'

const Login = () => {
    const navigate = useNavigate();
    const [userid, setUserid] = useState('');
    const [password, setPassword] = useState('');
    const [failMsg, setFailMsg] = useState('');

    const loginClick = () => {
        loginAPI(userid, password).then(res => {
            if (res) {
                // sessionStorage.setItem('access_token', res.access_token)
                localStorage.setItem('access_token', res.access_token)
                window.location.replace('/')
            } else {
                setFailMsg('아이디나 비밀번호를 다시 입력하세요')
            }
        })
    }


    return (
        <div className={`${styles.login}`}>
            <div className={styles.login_wrapper}>
                <div className={styles.login_card}>
                    <img src={logo} className={styles.logo} alt="투디지트 로고" onClick={() => navigate('/')}/>
                    <form>
                        <div className={styles.input_form}>
                            <p className={styles.label}>아이디</p>
                            <TextField name="username" type="text" className={styles.input}
                                       sx={{'& .MuiInputBase-adornedStart': {paddingLeft: '0'}}}
                                       InputProps={{
                                           startAdornment: (
                                               <InputAdornment position="start" sx={{maxHeight: '54px', height: '100%', backgroundColor: '#F0F2F6', padding: '12px'
                                               }}>
                                                   <PersonOutlineOutlinedIcon/>
                                               </InputAdornment>
                                           ),
                                       }}
                                       onChange={(e) => setUserid(e.target.value)}/>
                        </div>
                        <div className={styles.input_form}>
                            <p className={styles.label}>비밀번호</p>
                            <TextField className={styles.input} name="password" type="password"
                                       sx={{'& .MuiInputBase-adornedStart': {paddingLeft: '0'}}}
                                       InputProps={{
                                           startAdornment: (
                                               <InputAdornment position="start" sx={{maxHeight: '54px', height: '100%', backgroundColor: '#F0F2F6', padding: '12px'}}>
                                                   <KeyIcon/>
                                               </InputAdornment>
                                           ),
                                       }}
                                       onChange={(e) => setPassword(e.target.value)}
                                       onKeyUp={(e)=>{
                                           if(e.keyCode === 13){
                                               loginClick()
                                           }
                                       }}/>
                        </div>
                        <div className={styles.fail_msg}>{failMsg}</div>
                        <Button id={styles.login_btn} variant='contained' onClick={loginClick}>로그인</Button>
                    </form>
                    <div className={styles.join_wrapper}>
                        <span className={styles.join} onClick={() => navigate('/join/terms')}>회원가입 |</span>
                        <span className={`${styles.request} ${styles.join}`}
                              onClick={() => window.open('https://pf.kakao.com/_AUixjK', '_blank')}>문의하기</span>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Login;
